<template>
  <p>
    Our <strong>AI-Powered Invoice Processing Solution</strong> is designed to save Auto Collision Centers time and effort by automating invoice data
    entry. Since our service operates on a <strong>pay-per-scan</strong> basis, you might wonder why a subscription is also required.
  </p>

  <h5>The Subscription Ensures:</h5>
  <ul>
    <li><strong>✅ Account Setup & Secure Access</strong> – Your subscription establishes your account, giving you secure access to our platform.</li>
    <li><strong>✅ Billing & Payment Simplicity</strong> – We streamline payments for both the subscription and per-invoice charges.</li>
    <li><strong>✅ Continuous Platform Enhancements</strong> – Ongoing improvements, AI advancements, and enhanced security.</li>
    <li><strong>✅ Affordable, Flexible Pricing</strong> – A low-cost subscription plus a transactional model that fits your business.</li>
  </ul>

  <div class="pricing">
    <p><strong>$20/month or $200/year</strong> (Save $40 annually!)</p>
    <p><strong>With Auto-Fill: $40/month or $400/year</strong> (Save $80 annually!)</p>
    <p><strong>Pennies per invoice</strong> – Pay only for what you use!</p>
    <p><strong>Cancel Anytime!</strong></p>
  </div>
</template>
<script>
export default {
  name: 'OnboardOptions'
}
</script>
<style lang="scss" scoped>
.pricing {
  background: #0073e6;
  color: #fff;
  padding: 15px;
  text-align: center;
  border-radius: 5px;
  margin-top: 20px;
}
.pricing p {
  margin: 5px 0;
  font-size: 18px;
}
</style>
